import { useState } from 'react';
import { Spinner } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import CommProfileHeader from '../../../Exhibitor/Profile/CommProfileHeader';
import SlotCreate from '../../../B2BBuyerSeller/B2BProfile/Slot/SlotCreate';
import { useExhibitorAuthContext } from '../../../../Context/AuthContex/ExhibitorAuthContext';
import ExhibitorAvailSlot from './ExhibitorAvailSlot';

function CreateExhibitorMeeting() {
  const [toggle, setToggle] = useState<boolean>(false);
  const {
    state: { exhibitorUser },
    dispatch: authDispatch,
  } = useExhibitorAuthContext();
  return (
    <>
      <CommProfileHeader
        addHeadingTitle={`Add new Slots`}
        listHeadingTitle='Slot List'
        createBtnText='Add Slots'
        toggle={toggle}
        setToggle={setToggle}
        notShowingRightSide
      />

      <div className='profile-right-side px-3 py-3'>
        {toggle ? (
          <SlotCreate
            user_id={Number(exhibitorUser?.user_fair_member_id)}
            type='Exhibitor'
            handleClose={() => setToggle(!toggle)}
          />
        ) : (
          <div className='profile-right-info pt-3 ps-2'>
            {false ? (
              <div className='text-center mt-3'>
                <Spinner animation='border' variant='primary' />
              </div>
            ) : (
              <>
                <ExhibitorAvailSlot
                  user_id={Number(exhibitorUser?.user_fair_member_id)}
                  type='Exhibitor'
                />
              </>
            )}
          </div>
        )}
      </div>
    </>
  );
}

export default CreateExhibitorMeeting;
